var map = {
	"./backgrounds/initial.vert.glsl": 34,
	"./backgrounds/polka.vert.glsl": 35,
	"./building.vert.glsl": 36,
	"./fakeBox.vert.glsl": 37,
	"./overlays/opening_overlay.vert.glsl": 38,
	"./overlays/vignette.vert.glsl": 39,
	"./post/pass.vert.glsl": 21
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;



//////////////////
// WEBPACK FOOTER
// ./src/shaders ^\.\/.*\.vert\.glsl$
// module id = 33
// module chunks = 0